(function () {
    'use strict';

    function requestForProposalFindRespondentsController($scope, $timeout, $state, $filter, milestones,
        milestoneModalService, notifyService, requestForProposalStateService, requestForProposalResponseDataService, mailRequestDataService,
        sessionData, entitySearchConfiguration, adminEntitySearchConfiguration, rfpResponses) {
        var vm = this;
        vm.rfpData = requestForProposalStateService.get();
        vm.rfpId = vm.rfpData.Id.split('/')[1];
        vm.canAdvance = false;
        vm.config = entitySearchConfiguration;
        vm.compositeAttributes = [];
        vm.showResults = vm.rfpData.ApplicantAttributes.length > 0;
        vm.canAdvance = vm.rfpData.ApplicantAttributes.length > 0;
        vm.pendingUpdate = false;
        vm.sessionData = sessionData;
        vm.rfpResponses = rfpResponses;

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.activateSearchOptions = function () {
            vm.rfpData.ApplicantAttributes = [];
            vm.showResults = false;
            vm.pendingUpdate = true;
        }

        // NEW STUFF

        vm.rfpRespondentsToIgnore = [];
        vm.attributes = [];
        vm.showCriteria = false;

        // have to map pre-existing attributes for the searchDataService
        vm.rfpData.ApplicantAttributes.forEach(function (attribute) {
            attribute.value = attribute.Value;
        });

        vm.results = [];
        vm.showResults = false;
        vm.config = entitySearchConfiguration;
        vm.compositeAttributes = [];
        updateRespondentsToIgnore();

        function updateRespondentsToIgnore() {
            // when we are an admin, we can select applicants
            vm.rfpRespondentsToIgnore = vm.rfpResponses.map(function (response) {
                return {
                    'EntityId': response.EntityId
                }
            });
        }

        if (vm.sessionData.IsAdminEntity && adminEntitySearchConfiguration) {
            vm.hasAdminSearch = true;
            vm.adminApplicantAttributes = {};
            vm.adminAttributes = {};
            vm.adminResults = [];
            vm.showAdminResults = true;
            vm.adminConfig = adminEntitySearchConfiguration;
            vm.adminPageIndex = 0;
            vm.adminPageSize = 5;
            vm.adminTotalItems = 0;
            if (adminEntitySearchConfiguration.DefaultPageSize) {
                vm.adminPageSize = adminEntitySearchConfiguration.DefaultPageSize;
            };
        }

        $scope.$watch(function () { return vm.results; },
            function (newVal) {
                if (newVal) {
                    vm.compositeAttributes = _.uniq(vm.rfpData.ApplicantAttributes.concat(vm.attributes),
                        function(item) { return item.Name; });
                    vm.updateNoResults();
                }
            }
        );

        vm.updateNoResults = function () {
            var resultsCopy = vm.results.filter(function () { return true; });
            var filteredResults = $filter('excludeByArrayProperty')(resultsCopy, 'Id', vm.rfpRespondentsToIgnore, 'EntityId');
            vm.noResults = filteredResults.length === 0;

            vm.hasCompositeAttributes = (vm.compositeAttributes.length !== 0);
        }

        $scope.$watch(function () { return vm.adminResults; },
            function (newVal) {
                if (newVal) {
                    vm.updateNoAdminResults();
                }
            }
        );

        vm.updateNoAdminResults = function () {
            var adminResultsCopy = vm.adminResults.filter(function () { return true; });
            var filteredResults = $filter('excludeByArrayProperty')(adminResultsCopy, 'Id', vm.rfpRespondentsToIgnore, 'EntityId');
            vm.noAdminResults = filteredResults.length === 0;
        }

        vm.contactRespondent = function (entity) {
            mailRequestDataService.sendConnectionRequest({
                RequesterEntityId: sessionData.EntityId,
                RequesteeEntityId: entity.Id
            }).then(function (data) {
                notifyService.notify('We sent a notification to ' + entity.CompanyDetails.Name);
            });
        }

        vm.toggleRespondent = function (entity) {
            // create rfp response
            var newRfpResponse = {
                RequestForProposalId: vm.rfpData.Id,
                EntityId: entity.Id
            };

            if (!entity.isSelected) {
                requestForProposalResponseDataService.createRequestForProposalResponse(newRfpResponse).then(function (data) {
                    vm.rfpResponses.push(data);
                    notifyService.notify('You made an rfp response available for ' + data.RequestForProposalResponseEntity.CompanyDetails.Name);

                    mailRequestDataService.sendRequestForProposalResponseCreated({
                        RequestForProposalId: vm.rfpData.Id,
                        RequestForProposalResponseId: data.Id,
                        EntityId: vm.sessionData.EntityId
                    });
                });
            }
            else {
                var matchingResponse = vm.rfpResponses.find(function (response) {
                    return response.EntityId === entity.Id;
                });

                if (!matchingResponse) {
                    throw new Error('Could not find rfp response to delete');
                }

                requestForProposalResponseDataService.deleteRequestForProposalResponse(matchingResponse.Id)
                    .then(function (data) {
                        var removedResponse = vm.rfpResponses.splice(vm.rfpResponses.indexOf(matchingResponse), 1);
                        notifyService.notify('You deleted the rfp response for ' + removedResponse[0].RequestForProposalResponseEntity.CompanyDetails.Name);
                    })
                    .catch(function (error) {
                        notifyService.notify('There was an error deleting the rfp response');
                    });
            }

            entity.isSelected = !entity.isSelected;
            updateRespondentsToIgnore();
        }

        vm.selectEntityActions = vm.sessionData.IsAdminEntity
            ? {
                toggleRespondent: {
                    label: "Select",
                    call: vm.toggleRespondent
                }
            }
            : {
                contactRespondent: {
                    label: "Contact",
                    call: vm.contactRespondent
                },
                toggleRespondent: {
                    label: "Select",
                    call: vm.toggleRespondent
                }
            };

        vm.adminSelectEntityActions = {
            toggleRespondent: {
                label: "Select",
                call: vm.toggleRespondent
            }
        }
    }

    requestForProposalFindRespondentsController.$inject = ['$scope', '$timeout', '$state', '$filter', 'milestones',
        'milestoneModalService', 'notifyService', 'requestForProposalStateService', 'requestForProposalResponseDataService', 'mailRequestDataService',
        'sessionData', 'entitySearchConfiguration', 'adminEntitySearchConfiguration', 'rfpResponses'];

    angular.module('ecap.requestForProposal').controller('requestForProposalFindRespondentsController', requestForProposalFindRespondentsController);
})();
